// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__62gR7","title":"style_title__1AhBI","text":"style_text__ZT0hN","CTA":"style_CTA__kjdyd"};